export enum MessagePayloadType {
  URI = 'URI',
  Patient = 'patient',
  IntegratedCare = 'integratedcare',
  SingleOrder = 'singleOrder',
  Document = 'document',
  InstitutionDocument = 'institutionDocument',
  Institution = 'institution',
  Attachment = 'attachment',
  Note = 'note',
  Appointment = 'appointment',
  NursingHome = 'nursingHome',
}
